import React from 'react';

class EndQuoteContainer extends React.Component {
    render(){
        return(
            <div>
                <h1>Quote container</h1>
                
            </div>
        );
    }
}

export default EndQuoteContainer;


// WEBPACK FOOTER //
// ./src/EndQuote/EndQuoteContainer.js